import { HYDRATE } from 'next-redux-wrapper';
import { Footer, FooterTypes } from '@model/content';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { WritableDraft } from 'immer';

/* ***************** *
 *       TYPES       *
 * ***************** */

export type FooterState = {
  main: Footer | null;
  checkout: Footer | null;
};

export interface SetFooterPayload {
  footerType: FooterTypes;
  footer: Footer;
}

/* ***************** *
 *   ACTION TYPES    *
 * ***************** */

export enum FooterActions {
  NAME = '@CONTENT/FOOTER',
  SET_FOOTER = '@CONTENT/SET_FOOTER'
}

/* ***************** *
 *     REDUCER       *
 * ***************** */

export const INITIAL_FOOTER_STATE: FooterState = {
  main: null,
  checkout: null
};

const footerSlice = createSlice({
  name: FooterActions.NAME,
  initialState: INITIAL_FOOTER_STATE,
  reducers: {
    setFooter: (state: WritableDraft<FooterState>, action: PayloadAction<SetFooterPayload>) => {
      return { ...state, [action.payload.footerType]: action.payload.footer };
    }
  },
  extraReducers: (builder) => {
    builder.addCase(HYDRATE, (state: WritableDraft<FooterState>, action: any) => {
      if (action.payload.footer.main || action.payload.footer.checkout) {
        return action.payload.footer;
      }
      return state;
    });
  }
});

export const { setFooter } = footerSlice.actions;
export const footerReducer = footerSlice.reducer;
